import { render } from "./FeatureSectionThree.vue?vue&type=template&id=c6ffd5ee"
import script from "./FeatureSectionThree.vue?vue&type=script&lang=js"
export * from "./FeatureSectionThree.vue?vue&type=script&lang=js"

import "./FeatureSectionThree.vue?vue&type=style&index=0&id=c6ffd5ee&lang=css"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__